<template>
  <div
    :id="id"
    :style="{ width: '95%', height: '100%', margin: '0 auto' }"
  ></div>
</template>

<script>
export default {
  props: ["id", "chartsData"],
  data() {
    return {};
  },
  watch: {
    chartsData: {
      handler(newvalue, oldvalue) {
        this.drawLine();
      },
      deep: true,
    },
  },

  methods: {
    drawLine() {
      let _this = this;
      if (document.getElementById(this.id) == null) {
        return;
      }
      this.$echarts.dispose(document.getElementById(this.id));
      let myChart = this.$echarts.init(document.getElementById(this.id));
      myChart.setOption({}, true);
      let option = {
        color: ["#31E9E5", "#6569FF ", "#309DF6"],
        tooltip: {
          trigger: "item",
          formatter: `{b}: {c} ({d}%)`,
        },
        legend: {
          orient: "vertical",
          bottom: "bottom",
        },
        series: [
          {
            type: "pie",
            radius: "70%",
            label: {
              formatter: function (param) {
                return param.percent + "%";
              },
            },
            data: [
              { value: 1048, name: "紧急" },
              { value: 735, name: "重要" },
              { value: 580, name: "一般" },
            ],

            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
          },
        ],
      };

      myChart.setOption(option, true);
      setTimeout(() => {
        window.addEventListener("resize", () => {
          myChart.resize();
        });
      }, 20);
    },
  },
  mounted() {
    this.drawLine();
  },
};
</script>

<style scoped lang="scss">
</style>
